import { Component } from "react";
import { connect } from "react-redux";
import AbsenceForm from "./AbsenceForm";
import {
    getAbsencesActivityTypes,
    getCounters,
    redirect,
    resetAbsenceSelection,
} from "../../redux/absences/absencesActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

class CreateAbsence extends Component {
    constructor(props) {
        super(props);

        if (props.absences.activityTypes.length === 0) {
            this.props.resetRedirect();
            this.props.resetAbsenceSelection(this.props.activeUser.emp_id, this.props.activeUser.id);
            this.props.getAbsencesActivityTypes(
                this.props.absences.absenceCreationFields,
                this.props.absenceDetails,
                this.props.activeUser,
                true
            );
        } else {
            let activityType = props.absences.activityTypes.filter(
                (at) => at.report_type === props.activeUser.weekly_report_type
            )[0].id;
            props.getCounters(props.activeUser.emp_id, [], activityType, props.activeUser.id);
        }

        if (
            (!props.absences.editionState.creationMode &&
                !props.absences.editionState.updateMode &&
                !props.absences.editionState.validationMode) ||
            props.activeUser === null ||
            props.activeUser === undefined
        )
            props.history.push("/absences");
    }

    render() {
        return <AbsenceForm readonly={false} />;
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
        activeUser: state.activeUser,
        absenceDetails: state.absences.absenceDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCounters: (empId, details, defaultAbsenceTypeId, userId) =>
            dispatch(getCounters(empId, details, defaultAbsenceTypeId, userId)),
        resetRedirect: () => dispatch(redirect(null)),
        resetAbsenceSelection: (empId, userId) => dispatch(resetAbsenceSelection(empId, userId)),
        getAbsencesActivityTypes: (absenceCreationFields, details, activeUser, callGetCounters) =>
            dispatch(getAbsencesActivityTypes(absenceCreationFields, details, activeUser, callGetCounters)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CreateAbsence);
